import {
    Box,
    Button,
    Flex,
    NumberInput,
    NumberInputField,
    SimpleGrid,
    Text,
} from '@chakra-ui/react';
import { FiChevronLeft } from 'react-icons/fi';
import { MyTransactionsSection } from './components/DashboardStyles';
import { useNavigate } from 'react-router-dom';

const topUpBtns = ['₦10,000', '₦20,000', '₦30,000', '₦50,000', '₦100,000', '₦200,000'];

export default function FundWallet() {
    const navigate = useNavigate();
    return (
        <MyTransactionsSection>
            <Box p="4">
                <Flex mt="2">
                    <Box onClick={() => navigate(-1)}>
                        <FiChevronLeft fontWeight="600" />
                    </Box>
                </Flex>
                <Flex mt="3" flexDir="column" alignItems="center">
                    <Text mb="3" color="#000000">
                        Enter the amount of the top up
                    </Text>
                    <NumberInput>
                        <NumberInputField
                            height="20"
                            textAlign="center"
                            fontSize="4xl"
                            fontWeight="bold"
                        />
                    </NumberInput>
                </Flex>
                <SimpleGrid columns="3" mt="8" spacing="3">
                    {topUpBtns.map((btn) => (
                        <Box
                            _hover={{ bg: '#1b3b5f', color: '#fff', border: '1px solid #1b3b5f' }}
                            textAlign="center"
                            borderRadius="3xl"
                            px="2"
                            py="4"
                            border="1px solid #1e1e1e">
                            {btn}
                        </Box>
                    ))}
                </SimpleGrid>
                <Button
                    w="full"
                    backgroundColor="#1b3b5f"
                    fontWeight="normal"
                    mt="8"
                    p="6"
                    borderRadius="2xl"
                    colorScheme="blue">
                    Continue
                </Button>

                <Text mt="4" color="#00000090" textAlign="center">
                    Balance: ₦30,000
                </Text>
            </Box>
        </MyTransactionsSection>
    );
}
